export interface BarChartDataPoint {
  year: number;
  category: string;
  value: number;
}

export interface LineChartDataPoint {
  year: number;
  value: number;
  series: string;
}

export interface PieChartDataPoint {
  name: string;
  y: number;
}

export const barChartData: BarChartDataPoint[] = [
  { year: 2020, category: "Product A", value: 120 },
  { year: 2020, category: "Product B", value: 150 },
  { year: 2020, category: "Product C", value: 90 },
  { year: 2021, category: "Product A", value: 140 },
  { year: 2021, category: "Product B", value: 180 },
  { year: 2021, category: "Product C", value: 110 },
  { year: 2022, category: "Product A", value: 160 },
  { year: 2022, category: "Product B", value: 200 },
  { year: 2022, category: "Product C", value: 130 },
  { year: 2023, category: "Product A", value: 180 },
  { year: 2023, category: "Product B", value: 220 },
  { year: 2023, category: "Product C", value: 150 },
];

export const lineChartData: LineChartDataPoint[] = [
  { year: 2020, value: 450, series: "Sales" },
  { year: 2021, value: 520, series: "Sales" },
  { year: 2022, value: 580, series: "Sales" },
  { year: 2023, value: 620, series: "Sales" },
  { year: 2020, value: 380, series: "Revenue" },
  { year: 2021, value: 420, series: "Revenue" },
  { year: 2022, value: 480, series: "Revenue" },
  { year: 2023, value: 550, series: "Revenue" },
  { year: 2020, value: 280, series: "Profit" },
  { year: 2021, value: 320, series: "Profit" },
  { year: 2022, value: 380, series: "Profit" },
  { year: 2023, value: 420, series: "Profit" },
];

export const pieChartData: PieChartDataPoint[] = [
  { name: "Desktop", y: 45.2 },
  { name: "Mobile", y: 32.8 },
  { name: "Tablet", y: 12.5 },
  { name: "Other", y: 9.5 },
];
